module.exports = __webpack_public_path__ + "assets/img/rafa.7639b089.jpg";